module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/battles_28.e022760f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/battles_28.png
// module id = 3089
// module chunks = 11